import React from 'react';
import { motion } from 'framer-motion';

interface ArchitectureDiagramProps {
  steps: string[];
  className?: string;
}

function ArchitectureDiagram({ steps, className = '' }: ArchitectureDiagramProps) {
  if (!steps?.length) return null;

  return (
    <div className={`flex flex-col items-center gap-0 ${className}`}>
      {steps.map((step, index) => (
        <React.Fragment key={`${step}-${index}`}>
          <motion.div
            initial={{ opacity: 0, y: 12, filter: 'blur(4px)' }}
            whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 1.02 }}
            className="w-full max-w-[220px] px-4 py-2.5 rounded-md border border-line bg-canvas-muted text-center shadow-soft"
          >
            <span className="text-xs font-medium text-ink">{step}</span>
          </motion.div>
          {index < steps.length - 1 && (
            <motion.div
              initial={{ opacity: 0, scaleY: 0 }}
              whileInView={{ opacity: 1, scaleY: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.25, delay: index * 0.08 + 0.06 }}
              className="flex flex-col items-center py-1"
              aria-hidden
            >
              <div className="w-px h-3 bg-line-strong" />
              <span className="text-ink-faint text-[10px] leading-none">↓</span>
            </motion.div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default ArchitectureDiagram;
